import { Checkbox, Collapse, Message, Popover, Tag, Button  } from "@arco-design/web-react";
import React, { useState } from "react";
import VoiceSlider from "./VoiceSlider/VoiceSlider";
import TimberSelector from "./TimbreConfig/TimbreSelector/TimbreSelector";
import CustomTimbreSelector from "./TimbreConfig/CustomTimbreSelector/CustomTimbreSelector";
import "./VoiceConfig.less";
import VideoConfigCard, {
  VideoConfigCardContainer,
  VideoConfigCardHeader,
} from "../../UIComponents/VideoConfigCard/VideoConfigCard";
import { getTimbre } from "@/services/mixCutDetail/mixCutDetail";
import useRequest from "@/requestHooks/mixCutDetail/useRequest";
import { observer } from "mobx-react";
import QuickStore from "@/stores/quickCutStore";
import { IconClose } from "@arco-design/web-react/icon";

const CollapseItem = Collapse.Item;

export interface IVoiceConfig {
  style: React.CSSProperties;
  speedValue: number;
  pitchValue: number;
  speekerId: string;
  speaker: any[];
  volume: number;
  handleSpeedValueChange: (e: number) => void;
  handlePitchValueChange: (e: number) => void;
  handleSpeekerIdChange: (
    e: string,
    name: string,
    rate: number,
    platform: string,
    lang: string,
    gender: string,
    type: string,
    speaker_style: string,
    avatar_url: string,
    short_name: string
  ) => void;
  handleVolumeChange: (e: number) => void;
  handleGlobalCaptionChange?: (e: boolean) => void;
  emitTimbreSelector: (e) => void;
}

const VoiceConfig: React.FC<IVoiceConfig> = observer((props) => {
  const {
    style,
    speedValue,
    pitchValue,
    volume,
    handlePitchValueChange,
    handleSpeedValueChange,
    handleSpeekerIdChange,
    handleVolumeChange,
    emitTimbreSelector,
    speaker,
  } = props;
  const [state, setState] = useState(true);
  const { data, handleRequest } = useRequest({
    request: getTimbre,
    initSearchData: { type: 1, lang: "cn", gender: 2 },
  });
  const [gender, setGender] = useState(2);
  const [timbreSelectorId, setTimbreSelector] = useState(1);
  // 移除未使用的状态
  const [, setActiveKey] = useState(["2"]);
  const [lang, setLang] = useState("cn");
  const [selectAll, setSelectAll] = useState(false);
  const handleSelectAll = (checked: boolean, currentPageData: any[]) => {
    setSelectAll(checked);
    const currentSpeakerIds = QuickStore.quickcutData.settings.copy.voice.speaker.map(item => item.speaker_id);

    if (checked) {
      // 全选逻辑：添加当前页面未选中的声优
      const newSpeakers = currentPageData
        .filter(item => !currentSpeakerIds.includes(item.speaker_id))
        .map(item => ({
          speaker_name: item.name,
          speaker_id: item.speaker_id,
          default_speed_rate: item.speech_rate,
          emotion: "",
          type: item.cluster,
          lang: item.lang,
          platform: item.platform,
          gender: item.gender,
          speaker_style: item.speaker_style,
          url: item.url
        }));

      // 检查总数是否超过200
      const totalCount = currentSpeakerIds.length + newSpeakers.length;
      if (totalCount > 200) {
        Message.warning('最多只能选择200个');
        setSelectAll(false);
        return;
      }

      if (newSpeakers.length > 0) {
        QuickStore.quickcutData.settings.copy.voice.speaker.push(...newSpeakers);
      }
    } else {
      // 取消全选逻辑：只移除当前页面的声优
      const currentPageIds = currentPageData.map(item => item.speaker_id);
      QuickStore.quickcutData.settings.copy.voice.speaker =
        QuickStore.quickcutData.settings.copy.voice.speaker
          .filter(speaker => !currentPageIds.includes(speaker.speaker_id));
    }
  };

  const LangObj = {
    "1": {
      lang: "cn",
      type: 1,
      gender: gender,
    },
    "3": {
      lang: "en",
      type: 3,
      gender: gender,
    },
    "4": {
      lang: "ja",
      type: 4,
      gender: gender,
    },
    "5": {
      lang: "ko-KR",
      type: 5,
      gender: gender,
    },
    "6": {
      type: 6,
    },
  };
  const handleTimbreSelectorChange = (e: number) => {
    setSelectAll(false);
    emitTimbreSelector(e);
    setTimbreSelector(e);
    setLang(LangObj[e].lang);
    if (e === 6) {
      handleRequest({ ...LangObj[e], status: 1 });
    } else {
      handleRequest({ ...LangObj[e] });
    }
  };

  // 切换折叠状态
  const changeCollapse = (e: string) => {
    setSelectAll(false);
    if (e === "2") {
      if (timbreSelectorId === 6) {
        handleRequest({ type: timbreSelectorId, lang: lang, status: 1 }); // 女声
      } else {
        handleRequest({ type: timbreSelectorId, lang: lang, gender: 2 }); // 女声
      }
      setGender(2);
    } else if (e === "1") {
      if (timbreSelectorId === 6) {
        handleRequest({ type: timbreSelectorId, lang: lang, status: 1 }); // 男声
      } else {
        handleRequest({ type: timbreSelectorId, lang: lang, gender: 1 }); // 男声
      }
      setGender(1);
    } else {
      handleRequest({ type: 2, lang: lang, status: 1, gender: 1 }); // 方言
    }
    setActiveKey([String(e)]);
  };

  return (
    <div style={style}>
      <VideoConfigCard>
        <VideoConfigCardHeader
          headerLeft={
            <>
              <span>设置配音</span>
            </>
          }
          headerRight={
            <>
              {/*{*/}
              {/*  QuickStore.quickcutData.settings.copy.voice.speaker.map((item, ))*/}
              {/*}*/}

              {QuickStore.quickcutData.settings.copy.voice.speaker?.length >
                0 && (
                  <div className={"total"}>
                  <span>
                    已选择：
                    {
                      (
                        QuickStore.quickcutData.settings.copy.voice.speaker ||
                        []
                      ).length
                    }
                  </span>
                    <Popover
                      title=" "
                      trigger={"hover"}
                      position="br"
                      style={{height: 400, overflow: 'auto', background: '#fff'}}
                      className="chose-detail-popover-wrapper"
                      content={
                        <div className="chose-detail-content-wrapper">
                          <div className="chose-detail-content">
                            {(
                              QuickStore.quickcutData.settings.copy.voice
                                .speaker || []
                            ).map((item) => {
                              return (
                                <Tag
                                  key={item.speaker_id}
                                  color={"blue"}
                                  style={{margin: "2px 2px"}}
                                  className="chose-detail-popover-item"
                                >
                                <span>
                                  {item?.speaker_name}
                                  <IconClose
                                    style={{cursor: "pointer", marginLeft: 4}}
                                    onClick={() => {
                                      QuickStore.quickcutData.settings.copy.voice
                                        .speaker.splice(
                                        QuickStore.quickcutData.settings.copy
                                          .voice.speaker.findIndex(
                                          (i) => i.speaker_id === item.speaker_id,
                                        ),
                                        1,
                                      );
                                    }}
                                  />
                                </span>
                                </Tag>
                              );
                            })}
                          </div>
                        </div>
                      }
                    >
                      <span style={{
                        cursor: 'pointer',
                        color: 'rgb(22, 93, 255)',
                        margin: '0 10px'
                      }}>查看详情</span>
                    </Popover>
                    <span
                      onClick={() => {
                        setSelectAll(false);
                        QuickStore.quickcutData.settings.copy.voice
                          .speaker = []
                      }}
                      style={{ cursor: 'pointer' }}
                      className={"clear"}
                    >
                    清空
                  </span>
                  </div>
                )}
            </>
          }
        />
        <VideoConfigCardContainer style={{ height: state ? "auto" : 0 }}>
          {state ? (
            <>
              <div className="timbre-selector">
                <TimberSelector
                  handleActiveIndex={handleTimbreSelectorChange}
                  activeId={timbreSelectorId}
                />
                <VoiceSlider
                  style={{ marginTop: 14 }}
                  title={"语速"}
                  isZero={true}
                  step={0.1}
                  showTicks={true}
                  max={2.5}
                  value={speedValue}
                  handleSliderChange={handleSpeedValueChange}
                />
                <VoiceSlider
                  style={{ marginTop: 14 }}
                  title={"音调"}
                  isZero={true}
                  step={0.1}
                  showTicks={true}
                  max={2}
                  value={pitchValue}
                  handleSliderChange={handlePitchValueChange}
                />
                <VoiceSlider
                  style={{ marginTop: 14 }}
                  title={"音量"}
                  step={1}
                  min={0}
                  showTicks={false}
                  max={100}
                  value={Math.trunc(volume * 100)}
                  handleSliderChange={(e) => {
                    handleVolumeChange(e / 100);
                  }}
                />
              </div>
              <div className="quick-custom-timbre-select-card-group">
                <Collapse
                  accordion
                  defaultActiveKey={["2"]}
                  onChange={(e) => {
                    changeCollapse(e);
                  }}
                >
                  <CollapseItem header="女声" name="2">
                    <Checkbox
                      checked={selectAll}
                      onChange={(checked) => handleSelectAll(checked, data)}
                    >
                      全选 ({QuickStore.quickcutData.settings.copy.voice.speaker?.length || 0}/200)
                    </Checkbox>
                    <CustomTimbreSelector
                      activeType={timbreSelectorId}
                      key={`female-${data?.length || 0}`}
                      handleTimbreItemClick={(e) => {
                        const item = data.find((item) => item.speaker_id === e);
                        console.log(item , 'xxx')
                        if (!item) return;
                        const name = `${item.name}_${item.speaker_style}`;
                        handleSpeekerIdChange(
                          e,
                          name,
                          item.speech_rate,
                          item.platform,
                          item.lang,
                          item.gender,
                          item.cluster,
                          item.speaker_style,
                          item.url,
                          item.name
                        );
                      }}
                      activeId={speaker}
                      data={data}
                      min={6}
                    />
                  </CollapseItem>

                  <CollapseItem header="男声" name="1">
                    <Checkbox
                      checked={selectAll}
                      onChange={(checked) => handleSelectAll(checked, data)}
                    >
                      全选 ({QuickStore.quickcutData.settings.copy.voice.speaker?.length || 0}/200)
                    </Checkbox>
                    <CustomTimbreSelector
                      activeType={timbreSelectorId}
                      key={`male-${data?.length || 0}`}
                      handleTimbreItemClick={(e) => {
                        const item = data.find((item) => item.speaker_id === e);
                        if (!item) return;
                        const name = `${item.name}_${item.speaker_style}`;
                        handleSpeekerIdChange(
                          e,
                          name,
                          item.speech_rate,
                          item.platform,
                          item.lang,
                          item.gender,
                          item.cluster,
                          item.speaker_style,
                          item.url,
                          item.name
                        );
                      }}
                      activeId={speaker}
                      data={data}
                      min={6}
                    />
                  </CollapseItem>

                  {timbreSelectorId === 1 && (
                    <CollapseItem header="方言" name="3">
                      <Checkbox
                        checked={selectAll}
                        onChange={(checked) => handleSelectAll(checked, data)}
                      >
                        全选 ({QuickStore.quickcutData.settings.copy.voice.speaker?.length || 0}/200)
                      </Checkbox>
                      <CustomTimbreSelector
                        activeType={timbreSelectorId}
                        key={`dialect-${data?.length || 0}`}
                        handleTimbreItemClick={(e) => {
                          const item = data.find(
                            (item) => item.speaker_id === e
                          );
                          if (!item) return;
                          const name = `${item.name}_${item.speaker_style}`;
                          const rate = item.speech_rate;
                          const platform = item.platform;
                          const lang = item.lang;
                          const gender = item.gender;
                          const type = item.cluster;
                          const avatar_url = item.url;
                          const speaker_style = item.speaker_style;
                          console.log(item, 'item')
                          handleSpeekerIdChange(
                            e,
                            name,
                            rate,
                            platform,
                            lang,
                            gender,
                            type,
                            avatar_url,
                            speaker_style,
                            item.name
                          );
                        }}
                        activeId={speaker}
                        data={data}
                        min={6}
                      />
                    </CollapseItem>
                  )}
                </Collapse>
              </div>
            </>
          ) : (
            <></>
          )}
        </VideoConfigCardContainer>
      </VideoConfigCard>
    </div>
  );
});

export default VoiceConfig;
